export default "__VITE_ASSET__CLVZijEE__"